import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { QR_DEMO_BASE_PATH, useRoutes } from '../../hooks/useRoutes';
import useThrowAsyncError from '../../hooks/useThrowAsyncError';
import { getQrCodeInfoById, QrCodeInfo } from './api';

export default function LaunchQRCode({ isDemo = false }: { isDemo?: boolean }) {
  const { id } = useParams<{ id: string }>();
  const { buildAbsolutePath } = useRoutes();
  const handleError = useThrowAsyncError();

  const [qrCodeInfo, setQrCodeInfo] = useState<QrCodeInfo>();

  useEffect(() => {
    async function fetchQrCode() {
      try {
        const qrCodeInfo = await getQrCodeInfoById(id!);
        setQrCodeInfo(qrCodeInfo);
      } catch (error) {
        handleError(error);
      }
    }

    fetchQrCode();
  }, [handleError, id]);
  if (qrCodeInfo === undefined) return null;

  const path = buildAbsolutePath(['LINKED_MATERIAL_LINK'], undefined, isDemo ? QR_DEMO_BASE_PATH : undefined);
  const query = new URLSearchParams();

  query.set('moduleId', qrCodeInfo.moduleId);
  query.set('medialinkIds', qrCodeInfo.medialinkIds.join(','));

  return <Navigate to={`${path}?${query.toString()}`} replace />;
}
